import { initAxios } from '../../../utils/axiosHelper';

export interface EntityDocument {
  id: string;
  database_entity_id: string;
  database_id: string;
  group_id: string;
  file_name: string;
  content_type: string | null;
  file_size: number | null;
  uploaded_by: string | null;
  uploaded_by_name: string | null;
  created_at: string;
}

const basePath = (databaseId: string, databaseEntityId: string) =>
  `/bite-db/database/${encodeURIComponent(
    databaseId,
  )}/entity/${encodeURIComponent(databaseEntityId)}/documents`;

export const getEntityDocuments = async (
  databaseId: string,
  databaseEntityId: string,
): Promise<EntityDocument[]> => {
  const response = await initAxios().get(
    basePath(databaseId, databaseEntityId),
  );
  return response.data?.data || [];
};

export const uploadEntityDocument = async (
  databaseId: string,
  databaseEntityId: string,
  file: File,
  onProgress?: (progress: number) => void,
): Promise<EntityDocument[]> => {
  const client = initAxios();
  // Let the browser add the multipart boundary instead of inheriting the
  // JSON default from initAxios.
  delete client.defaults.headers.common['Content-Type'];
  delete (client.defaults.headers.post as Record<string, unknown>)[
    'Content-Type'
  ];
  delete (client.defaults.headers as Record<string, unknown>)['Content-Type'];
  const formData = new FormData();
  formData.append('file', file);
  const response = await client.post(
    basePath(databaseId, databaseEntityId),
    formData,
    {
      onUploadProgress: (event: any) => {
        if (!event.total || !onProgress) return;
        onProgress(Math.min(100, Math.round((event.loaded * 100) / event.total)));
      },
    },
  );
  return response.data?.data || [];
};

export const downloadEntityDocument = async (
  databaseId: string,
  document: EntityDocument,
): Promise<void> => {
  const response = await initAxios().get(
    `/bite-db/database/${encodeURIComponent(
      databaseId,
    )}/entity-documents/${encodeURIComponent(document.id)}/download`,
    { responseType: 'blob' },
  );
  const url = URL.createObjectURL(response.data as Blob);
  const anchor = window.document.createElement('a');
  anchor.href = url;
  anchor.download = document.file_name;
  window.document.body.appendChild(anchor);
  anchor.click();
  window.document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};

export const deleteEntityDocument = async (
  databaseId: string,
  documentId: string,
): Promise<void> => {
  await initAxios().delete(
    `/bite-db/database/${encodeURIComponent(
      databaseId,
    )}/entity-documents/${encodeURIComponent(documentId)}`,
  );
};
